import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Each slider checks `if (sliders.length)` before init, so it's a safe no-op
// on pages where that slider isn't present (no errors).

// Default Slider
const defaultSlider = () => {
    const sliders = document.querySelectorAll('.swiper-default');
    if (sliders.length) {
        sliders.forEach((el) => {
            new Swiper(el, {
                loop: true,
                speed: 500,
                autoplay: { delay: 1000, disableOnInteraction: false },
                simulateTouch: true,
                spaceBetween: 30,
                slidesPerView: 2,
                pagination: { el: '.swiper-pagination' },
                navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
            });
        });
    }
};

// Continuous Slider
const continuousSlider = () => {
    const sliders = document.querySelectorAll('.swiper-continous');
    if (sliders.length) {
        sliders.forEach((el) => {
            new Swiper(el, {
                loop: true,
                speed: 1500,
                autoplay: { delay: 0, disableOnInteraction: false },
                simulateTouch: true,
                spaceBetween: 30,
                slidesPerView: 2,
            });
        });
    }
};

// Flagship Projects Slider — peek + right-bleed, arrows live outside the .swiper
const flagshipSlider = () => {
    const sliders = document.querySelectorAll('.projects-slider');
    if (sliders.length) {
        sliders.forEach((el) => {
            const swiper = new Swiper(el, {
                slidesPerView: 1.2,
                spaceBetween: 24,
                watchOverflow: true,
                loop: true,
                autoplay: { delay: 3000, disableOnInteraction: false },
                breakpoints: {
                    768:  { slidesPerView: 2.2, spaceBetween: 24 },
                    1200: { slidesPerView: 2.4, spaceBetween: 37 },
                },
            });
            const section = el.closest('section') || document;
            section.querySelectorAll('.swiper-button-prev-wrap').forEach((b) => b.addEventListener('click', () => swiper.slideNext()));
            section.querySelectorAll('.swiper-button-next-wrap').forEach((b) => b.addEventListener('click', () => swiper.slidePrev()));
        });
    }
};

// Excellence Slider — service cards
const excellenceSlider = () => {
    const sliders = document.querySelectorAll('.exl-slider');
    if (sliders.length) {
        sliders.forEach((el) => {
            const swiper = new Swiper(el, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                watchOverflow: true,
                breakpoints: {
                    768:  { slidesPerView: 2.2, spaceBetween: 12 },
                    992:  { slidesPerView: 3.2, spaceBetween: 12 },
                    1200: { slidesPerView: 4.3, spaceBetween: 12 },
                },
            });
            const section = el.closest('section') || document;
            section.querySelectorAll('.exl-swiper-button-prev-wrap').forEach((b) => b.addEventListener('click', () => swiper.slideNext()));
            section.querySelectorAll('.exl-swiper-button-next-wrap').forEach((b) => b.addEventListener('click', () => swiper.slidePrev()));
        });
    }
};

// History timeline — draggable
const yearSlider = () => {
    const sliders = document.querySelectorAll('.year-slider');
    if (sliders.length) {
        sliders.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1.2,
                spaceBetween: 24,
                grabCursor: true,
                watchOverflow: true,
                breakpoints: {
                    768:  { slidesPerView: 2.4 },
                    992:  { slidesPerView: 3.4 },
                    1200: { slidesPerView: 4.4 },
                    1600: { slidesPerView: 4.4, spaceBetween: 54 },
                },
            });
        });
    }
};

// Offer Slider — image cards
const offerSlider = () => {
    const sliders = document.querySelectorAll('.offer-slider');
    if (sliders.length) {
        sliders.forEach((el) => {
            const swiper = new Swiper(el, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                watchOverflow: true,
                breakpoints: {
                    768:  { slidesPerView: 2.2, spaceBetween: 24 },
                    1200: { slidesPerView: 3.2, spaceBetween: 24 },
                },
            });
            const section = el.closest('section') || document;
            section.querySelectorAll('.swiper-button-prev-offer').forEach((b) => b.addEventListener('click', () => swiper.slideNext()));
            section.querySelectorAll('.swiper-button-next-offer').forEach((b) => b.addEventListener('click', () => swiper.slidePrev()));
        });
    }
};

// Project gallery — draggable with pagination (pagination el is per-instance)
const gallerySlider = () => {
    const sliders = document.querySelectorAll('.gallery-slider');
    if (sliders.length) {
        sliders.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1,
                spaceBetween: 16,
                grabCursor: true,
                watchOverflow: true,
                pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
                breakpoints: {
                    768:  { slidesPerView: 2,   spaceBetween: 16 },
                    1200: { slidesPerView: 3, spaceBetween: 16 },
                },
            });
        });
    }
};

// Partner logo marquee — continuous auto-scroll
const partnerSlider = () => {
    const sliders = document.querySelectorAll('.partners-slider');
    if (sliders.length) {
        sliders.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 11,
                loop: true,
                speed: 4000,
                allowTouchMove: false,   // marquee only — no touch/drag sliding
                autoplay: { delay: 0, disableOnInteraction: false },
                breakpoints: { 992: { spaceBetween: 24 } },
            });
        });
    }
};

// Project / image slider — loop + autoplay
const projImageSlider = () => {
    const sliders = document.querySelectorAll('.proj-image-slider');
    if (sliders.length) {
        sliders.forEach((el) => {
            new Swiper(el, {
                speed: 500,
                simulateTouch: true,
                spaceBetween: 16,
                loop: true,
                slidesPerView: 1,
                watchOverflow: true,
                autoplay: { delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true },
                breakpoints: {
                    576: { slidesPerView: 2,   spaceBetween: 16 },
                    992: { slidesPerView: 3, spaceBetween: 16 },
                },
            });
        });
    }
};

const initSwipers = () => {
    // Re-entrant: the block editor re-renders a block's DOM wholesale and calls
    // this again, and a second Swiper on the same element stacks instances.
    // destroy(true, true) also unwinds loop mode's duplicated slides, so the
    // slide count stays put instead of climbing on every re-run.
    // No-op on the front end: nothing is initialised yet at DOMContentLoaded.
    document.querySelectorAll('.swiper').forEach((el) => {
        if (el.swiper) {
            el.swiper.destroy(true, true);
        }
    });

    defaultSlider();
    continuousSlider();
    flagshipSlider();
    excellenceSlider();
    yearSlider();
    offerSlider();
    gallerySlider();
    partnerSlider();
    projImageSlider();
};

// The block editor cannot import, so it needs a reachable entry point. This name
// must match CONFIG.initAll in inc/acf-blocks-editor.js.
if (typeof window !== 'undefined') {
    window.themeSiteSliders = initSwipers;
}

// Run now if the DOM is already parsed (deferred / combined scripts), else on DOMContentLoaded.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipers);
} else {
    initSwipers();
}
